(function ( $ ) {
     $.fn.renderMap = function (options) {
         var settings = $.extend({
            someOption: ""
        }, options);

        var objLink    = $(this);
        var lat        = parseFloat($(this).attr('data-lat'));
        var lng        = parseFloat($(this).attr('data-lng'));
        var zoom       = parseInt($(this).attr('data-zoom'));

        function _init() {
            objLink.each(function (index) {
                _renderMap($(this));
            });
        }

        function _renderMap(o){
            $.getScript( url+"/scripts/libs/leaflet.js", function( data, textStatus, jqxhr ) {
                var LeafIcon = L.Icon.extend({
                    options: {
                        iconSize:     [39, 55],
                        iconAnchor:   [19, 55]
                    }
                });



                var mbAttr = '',
                    mbUrl = 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png';
                var grayscale = L.tileLayer(mbUrl, {
                	maxZoom: 20,
                	attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
                });
                var map = L.map('map', {
                    center: [lat, lng],
                    zoom: zoom,
                    zoomControl: true,
                    layers: [grayscale],
                    scrollWheelZoom: false
                });

                map.zoomControl.setPosition('topright');
                $('#map .pin').each(function (index) {
                    icons  = new LeafIcon({iconUrl: $(this).attr('data-img')});
                    L.marker([parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))], {icon: icons}).addTo(map) .bindTooltip($(this).attr('data-text'),{
                         direction: 'top',
                         offset: [0, -31]
                     })
                    icons = '';
                })

            });
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$('#map').renderMap();
